import { ChartOptions } from "chart.js";
import { getTooltipLabel, yTicksCallback } from "./utils";

// 4 hours in minutes
export const STEP_SIZE = 240;
export const DEFAULT_ZOOM_LEVEL = 1;
export const TEXT_COLOR = "#BFBFBF";
export const CHART_HEIGHT = 170;
export const DEFAULT_Y_MAX = 100;

// minutes in day
export const DEFAULT_MAX_X_SCALE = 1440;

// Updating options by creating new object each time in component triggers chart state reset
// This is the issue for zoom level (etc.) persistence between rerenders
// Declared it as a function not just const value
// Declaring as const mean to use sharable instance that is mutated directly in each chart on the page
// and lead to bugs
// mutation of options described in official docs
// https://www.chartjs.org/docs/latest/developers/updates.html#updating-options

export const getDefaultOptions = (
  unitMeasurement: string
): ChartOptions<"line"> => ({
  maintainAspectRatio: false,
  parsing: false,
  elements: {
    point: {
      pointStyle: false,
    },
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestedMax: DEFAULT_MAX_X_SCALE,
      ticks: {
        stepSize: STEP_SIZE,
        color: TEXT_COLOR,
      },
      grid: {
        display: false,
      },
    },
    y: {
      beginAtZero: true,
      suggestedMax: DEFAULT_Y_MAX,
      ticks: {
        callback: yTicksCallback,
        color: TEXT_COLOR,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
      onHover: (event, item, legend) => {
        legend.chart.canvas.style.cursor = "pointer";
      },
      onLeave: (event, item, legend) => {
        legend.chart.canvas.style.cursor = "auto";
      },
    },
    annotation: { annotations: {} },
    tooltip: {
      callbacks: {
        label: getTooltipLabel(unitMeasurement),
      },
    },
    zoom: {
      limits: {
        x: {
          min: "original",
          max: "original",
          minRange: 1,
        },
        y: {
          min: "original",
          max: "original",
          minRange: 0.1,
        },
      },
      zoom: {
        wheel: { enabled: true, modifierKey: "ctrl" },
        pinch: { enabled: true },
      },
      pan: { enabled: true },
    },
  },
});
